import { render } from "./AddKoubeiDialog.vue?vue&type=template&id=5da4db62&scoped=true&ts=true"
import script from "./AddKoubeiDialog.vue?vue&type=script&lang=ts"
export * from "./AddKoubeiDialog.vue?vue&type=script&lang=ts"

import "./AddKoubeiDialog.vue?vue&type=style&index=0&id=5da4db62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da4db62"]])

export default __exports__